/**
 * CHECKOUT LOADER INLINE SOLUTION
 * 
 * Esta solução integra o código CSS diretamente no JavaScript
 * para garantir que a tela de carregamento seja exibida corretamente
 * independente do carregamento de arquivos externos.
 */

// Função para criar e injetar a tela de carregamento
function injectCheckoutLoader() {
  // Verifica se o loader já existe
  if (document.getElementById('orne-checkout-loader')) return;
  
  // 1. Criar elemento de estilo
  const style = document.createElement('style');
  style.id = 'checkout-loader-styles';
  style.textContent = `
    .orne-checkout-loader {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #FFFFFF;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 999999;
      opacity: 0;
      transition: opacity 0.3s ease-in-out;
      pointer-events: none;
    }
    
    .orne-checkout-loader.active {
      opacity: 1;
      pointer-events: all;
    }
    
    .orne-loader-spinner {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      border: 3px solid rgba(0, 0, 0, 0.1);
      border-top-color: #000000;
      animation: orne-spinner 1s linear infinite;
      margin-bottom: 25px;
    }
    
    .orne-loader-text {
      font-family: 'Inter', 'Helvetica Neue', sans-serif;
      font-size: 16px;
      color: #333333;
      margin-top: 20px;
      text-align: center;
      font-weight: 500;
      max-width: 250px;
      line-height: 1.4;
    }
    
    @keyframes orne-spinner {
      to {
        transform: rotate(360deg);
      }
    }
    
    @media screen and (max-width: 768px) {
      .orne-loader-spinner {
        width: 40px;
        height: 40px;
      }
      
      .orne-loader-text {
        font-size: 14px;
        max-width: 200px;
      }
    }
  `;
  
  // 2. Criar elemento HTML do loader
  const loaderElement = document.createElement('div');
  loaderElement.id = 'orne-checkout-loader';
  loaderElement.className = 'orne-checkout-loader';
  loaderElement.innerHTML = `
    <div class="orne-loader-spinner"></div>
    <div class="orne-loader-text">Preparando um checkout à altura do seu bom gosto...</div>
  `;
  
  // 3. Adicionar elementos ao DOM
  document.head.appendChild(style);
  document.body.appendChild(loaderElement);
  
  return loaderElement;
}

// Função para mostrar o loader
function showCheckoutLoader() {
  const loader = document.getElementById('orne-checkout-loader') || injectCheckoutLoader();
  
  // Forçar reflow para garantir que a animação funcione
  void loader.offsetWidth;
  
  // Ativar o loader
  loader.classList.add('active');
  
  // Esconder o loader da Yampi original (se existir)
  const yampiLoader = document.querySelector('.yampi-loader');
  if (yampiLoader) yampiLoader.style.display = 'none';
}

// Função para esconder o loader
function hideCheckoutLoader() {
  const loader = document.getElementById('orne-checkout-loader');
  if (!loader) return;
  
  loader.classList.remove('active');
}

// Interceptar cliques nos botões de checkout da PageFly
function interceptCheckoutButtons() {
  // Selector para o botão "Comprar agora" do PageFly
  const buyNowSelector = '[data-pf-type="ProductATC2"][data-checkout="cart"]';
  
  // Adicionar listeners aos botões
  document.querySelectorAll(buyNowSelector).forEach(button => {
    // Remover listeners anteriores (se existirem)
    button.removeEventListener('click', handleBuyNowClick);
    
    // Adicionar novo listener
    button.addEventListener('click', handleBuyNowClick);
    
    // Marcar botão como processado
    button.setAttribute('data-loader-attached', 'true');
    
    console.log('Interceptador anexado ao botão de compra:', button);
  });
}

// Manipulador para o clique no botão "Comprar agora"
function handleBuyNowClick(event) {
  // Não parar o evento completamente para permitir que o fluxo original continue
  // event.preventDefault();
  // event.stopPropagation();
  
  console.log('Clique em "Comprar agora" detectado!');
  
  // Mostrar a tela de carregamento
  showCheckoutLoader();
  
  // Não precisa fazer nada a mais - o redirecionamento já está funcionando
  // A tela de carregamento vai permanecer visível durante a navegação
}

// Função para verificar se o elemento DOM já está disponível
// e configura um MutationObserver para detectar novos botões
function setupButtonObserver() {
  // Procurar botões existentes
  interceptCheckoutButtons();
  
  // Configurar o observer para detectar novos botões
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        // Verificar se novos botões foram adicionados
        setTimeout(interceptCheckoutButtons, 300);
      }
    });
  });
  
  // Iniciar a observação do body para detectar mudanças
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
  
  // Retornar o observer para caso queira cancelá-lo depois
  return observer;
}

// Iniciar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupButtonObserver);
} else {
  setupButtonObserver();
}

// Também verificar novamente após o carregamento completo da página
window.addEventListener('load', interceptCheckoutButtons);

// Adicionar verificação periódica para garantir que todos os botões sejam capturados
// Isso ajuda com páginas que carregam conteúdo via AJAX
setInterval(interceptCheckoutButtons, 1000);

// Para fins de depuração - verificar se o script está funcionando
console.log('Script de interceptação de checkout carregado!');